import React, { PropTypes } from 'react';
import classNames from 'classnames';
import BurgerMenu from './BurgerMenu';


const Burger = ({ toggle, opened, items, lang }) => (
  <div>
    <div className="burger">
      <div
        onClick={toggle}
        className={classNames('navtoggle', 'lines-button', 'x2', 'menu-btn', { close: opened })}
      >
        <span className="lines"></span>
      </div>
    </div>
    {opened && <BurgerMenu toggle={toggle} items={items} lang={lang} />}
  </div>
);

Burger.propTypes = {
  items: PropTypes.object.isRequired,
  toggle: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
  opened: PropTypes.bool.isRequired,
};

export default Burger;



// WEBPACK FOOTER //
// ./common/components/Burger.js